import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import logo from '../images/logo.svg'
import LanguageSwitcher from './languageSwitcher'
import i18n from '../components/i18n'

const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
`

const NavToggle = styled.a`
  color: #000;
  text-decoration: none;
  font-weight: bold;
  font-size: .875rem;

  svg {
    display: inline-block;
    margin-left: .5rem;
  }

  &:hover {}

  &.white {
    color: #fff;

    svg path {
      fill: #fff;
    }
  }

  &.close svg {
    transform: rotate(180deg);
  }
`

const NavContainer = styled.div`
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transform: translateY(-100%);
  opacity: 0;
  transition: all .15s ease;
  overflow-y: auto;
  background-color: #fff;

  &.true {
    transform: translateY(0);
    opacity: 1;
  }
`

const NavHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;

  img {
    display: block;
    margin: 0;
  }

  @media (min-width: 40em) {
    padding: 2rem;
  }
`

const NavContent = styled.div`
  display: flex;
  flex: auto;
`

const NavLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 40em;
  margin: 0 auto;
`

const NavLink = styled(Link)`
  text-decoration: none;
  color: hsla(0,0%,0%,0.8);
  line-height: 1.75;

  h4 {
    font-size: 1.25rem;
    font-weight: 800;
    line-height: 1.75;
    margin-right: .5rem;
    text-align: center;
  }

  p {
    display: none;
    margin: 0;
  }

  &:hover {
    color: hsla(0,0%,0%,0.5);
  }

  @media (min-width: 40em) {
    margin: .125rem 0;
    font-size: 1rem;

    h4 {
      font-size: 1rem;
      text-align: left;
    }

    p {
      display: block;
    }
  }

  @media (min-width: 52em) {
    font-size: 1.25rem;

    h4 {
      font-size: 1.25rem;
    }
  }
`

class Navigation extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: []
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(index,e) {
    let clicked = this.state.clicked;
    clicked[index] = !clicked[index]
    this.setState({clicked: clicked});
  }

  render() {
    const pages = this.props.pages;
    const currentPath = this.props.currentPath
    const frontpages = ['/', '/en', '/sv']
    //let currentLanguage = this.props.currentLanguage
    const currentLanguage = i18n.language
    let linkColor = ''

    const browseText = {
      'fi': 'Selaa näyttelyä',
      'en': 'Menu',
      'sv': 'Meny'
    }

    if (frontpages.indexOf(currentPath) >= 0)
      linkColor = 'white'

    return (
      <NavigationWrapper>
        <LanguageSwitcher linkColor={linkColor} />

        <NavToggle href='#' className={linkColor} onClick={this.handleClick.bind(this,0)}>
          <span>{browseText[currentLanguage]}</span>
          <svg width="12" height="8" xmlns="http://www.w3.org/2000/svg"><path d="M11.414 2L10 .586l-4 4-4-4L.586 2 6 7.414z" fill="#000" fillRule="nonzero"/></svg>
        </NavToggle>

        <NavContainer className={this.state.clicked[0]}>
          <NavHeader>
            <Link to="/" onClick={this.handleClick.bind(this,0)}>
              <img src={logo} alt="Poliisimuseo" />
            </Link>
            <NavToggle href='#' className='close' onClick={this.handleClick.bind(this,0)}>
              <span>{browseText[currentLanguage]}</span>
              <svg width="12" height="8" xmlns="http://www.w3.org/2000/svg"><path d="M11.414 2L10 .586l-4 4-4-4L.586 2 6 7.414z" fill="#000" fillRule="nonzero"/></svg>
            </NavToggle>
          </NavHeader>

          <NavContent>
            <NavLinksWrapper>
              {pages
                .filter(
                  page => page.node.featuredContent === null &&
                  page.node.node_locale === currentLanguage)
                .map(({ node: page }, i) => {
                return (
                  <NavLink to={page.slug} key={i} onClick={this.handleClick.bind(this,0)}>
                    <div style={{ display: 'flex' }}>
                      <div style={{ width: '8rem' }}>
                        <h4 style={{ margin: 0 }}>{page.title}</h4>
                      </div>
                      <p>{page.subtitle}</p>
                    </div>
                  </NavLink>
                );
              })}
            </NavLinksWrapper>
          </NavContent>
        </NavContainer>
      </NavigationWrapper>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/navigation.js